import gql from "graphql-tag";
import PinnablePostFields from "../../fragments/engagement/PinnablePostFields";

export default gql`
  mutation PinPost($postId: ObjectID!) {
    pinPost(postId: $postId) {
      ...PinnablePostFields
    }
  }

  ${PinnablePostFields}
`;
